import React from 'react';
import { Box, Text } from 'ink';
import { useTheme } from '../../theme';
import { parsePatchToDiffLines } from './parse_patch';
import { DiffLineContent } from './DiffLineContent';

export interface DiffProps {
  patch: string;
  oldFilepath: string;
  newFilepath: string;
  containerChromeWidth?: number;
}

export const Diff: React.FC<DiffProps> = ({
  patch,
  oldFilepath,
  newFilepath,
  containerChromeWidth = 0,
}) => {
  const { tokens } = useTheme();
  const colors = tokens.background.diff;
  const isRenamed = oldFilepath !== newFilepath;

  const diffLines = React.useMemo(() => {
    if (!patch || patch.trim() === '') return null;
    return parsePatchToDiffLines(patch);
  }, [patch]);

  if (diffLines === null) {
    if (isRenamed) {
      return (
        <Box flexDirection="column" backgroundColor={colors.plain}>
          <Text dimColor>
            Renamed: {oldFilepath} → {newFilepath}
          </Text>
        </Box>
      );
    }
    return (
      <Box flexDirection="column" backgroundColor={colors.plain}>
        <Text dimColor>Diff: {oldFilepath}</Text>
        <Text>Files content is identical</Text>
      </Box>
    );
  }

  return (
    <Box flexDirection="column" backgroundColor={colors.plain}>
      {isRenamed && (
        <Text dimColor>
          Renamed: {oldFilepath} → {newFilepath}
        </Text>
      )}
      {diffLines.map((line, index) => (
        <DiffLineContent key={index} line={line} containerChromeWidth={containerChromeWidth} />
      ))}
    </Box>
  );
};
